const parseHhMm = (value) => {
    if (typeof value !== "string")
        return null;
    const parts = value.trim().split(":");
    if (parts.length !== 2)
        return null;
    const hour = Number(parts[0]);
    const minute = Number(parts[1]);
    if (!Number.isInteger(hour) || !Number.isInteger(minute))
        return null;
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59)
        return null;
    return { hour, minute };
};
const minutesOfDay = (hour, minute) => hour * 60 + minute;
const formatLocalTime = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).formatToParts(date);
    const hour = parts.find((p) => p.type === "hour")?.value ?? "00";
    const minute = parts.find((p) => p.type === "minute")?.value ?? "00";
    return { hhmm: `${hour}:${minute}`, label: `${hour}:${minute}` };
};
export const isWithinTradingSession = (schedule, now = new Date(), scopeLabel = "торговой сессии") => {
    const data = schedule ?? {};
    if (data.only_rth === false) {
        return { ok: true };
    }
    const start = parseHhMm(data.session_start ?? "10:00");
    const end = parseHhMm(data.session_end ?? "18:45");
    const timeZone = data.timezone ?? "Europe/Moscow";
    if (!start || !end) {
        return { ok: false, message: "Некорректное расписание торговой сессии в политике стратегии." };
    }
    const local = formatLocalTime(now, timeZone);
    const [h, m] = local.hhmm.split(":").map(Number);
    const current = minutesOfDay(h, m);
    const startMin = minutesOfDay(start.hour, start.minute);
    const endMin = minutesOfDay(end.hour, end.minute);
    const inSession = startMin <= endMin
        ? current >= startMin && current <= endMin
        : current >= startMin || current <= endMin;
    if (inSession) {
        return { ok: true };
    }
    const pad = (n) => String(n).padStart(2, "0");
    const window = `${pad(start.hour)}:${pad(start.minute)}–${pad(end.hour)}:${pad(end.minute)} (${timeZone})`;
    return {
        ok: false,
        message: `Вне ${scopeLabel}: сейчас ${local.label}, разрешено ${window}.`,
    };
};
